"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInCallShortcuts = void 0;
const react_1 = require("react");
const handleKeyDown = (event) => {
    var _a, _b, _c;
    const inputElementHasFocus = ['INPUT', 'TEXTAREA'].includes(((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.tagName) || '');
    if (event.shiftKey && !inputElementHasFocus) {
        const requestStreemshotButton = document.querySelector('[data-testid="streemshot-button"]');
        const camaerFlipButton = document.querySelector('[data-testid="FlipIcon-icon-button"]');
        const laserToolButton = document.querySelector('[data-testid="laser-pointer-button"]');
        const markerToolButton = document.querySelector('[data-testid="marker-button"]');
        const trayToggleButton = document.querySelector('[data-testid="tray-toggle-button"]');
        const addBookmarkButton = document.querySelector('[data-testid="add-bookmark-button"]');
        const toggleCameraButton = (_b = document.querySelector('[data-testid="Start Camera"]')) !== null && _b !== void 0 ? _b : document.querySelector('[data-testid="Stop Camera"]');
        const toggleMuteButton = (_c = document.querySelector('[data-testid="Unmute"]')) !== null && _c !== void 0 ? _c : document.querySelector('[data-testid="Mute"]');
        if (toggleCameraButton && toggleCameraButton.click && event.key.toUpperCase() === 'V') {
            toggleCameraButton.click();
        }
        if (toggleMuteButton && toggleMuteButton.click && event.key.toUpperCase() === 'A') {
            toggleMuteButton.click();
        }
        if (trayToggleButton && trayToggleButton.click && event.key.toUpperCase() === 'T') {
            trayToggleButton.click();
        }
        if (requestStreemshotButton &&
            requestStreemshotButton.click &&
            event.key.toUpperCase() === 'S') {
            requestStreemshotButton.click();
        }
        if (markerToolButton && markerToolButton.click && event.key.toUpperCase() === 'D') {
            markerToolButton.click();
        }
        if (laserToolButton && laserToolButton.click && event.key.toUpperCase() === 'Z') {
            laserToolButton.click();
        }
        if (camaerFlipButton && camaerFlipButton.click && event.key.toUpperCase() === 'F') {
            camaerFlipButton.click();
        }
        if (addBookmarkButton && addBookmarkButton.click && event.key.toUpperCase() === 'B') {
            // Delay the click so that the current Shift+B key press doesn't enter into the text field
            setTimeout(() => {
                addBookmarkButton.click();
            }, 10);
        }
    }
};
const useInCallShortcuts = () => {
    (0, react_1.useEffect)(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
};
exports.useInCallShortcuts = useInCallShortcuts;
//# sourceMappingURL=use_in_call_shortcuts.js.map